import React, { Component } from "react";
import axios from "axios";
import constant from "../../constant";
import Slider from "react-slick";
import "./style.scss";

import PriceComp from "../../components/PriceComp";
import PopupComp from "../../components/PopupComp";
import { LoadingComp } from "../../components/LoadingComp";

export default class Hosting extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      spaces: null,
      isLoading: true,
      isPopup: false,
      hostStatus: "",
      hostId: "",
      popupText1: "",
      popupText2: ""
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.hosting();
  }

  hosting = () => {
    let _this = this;

    axios
      .get(`${constant.phpHost}action/dashboard.php`, {
        params: {
          todo: "hosting_spaces",
          user_id: this.props.user_id
        }
      })
      .then(function(res) {
        if (_this._isMounted) {
          _this.setState({
            spaces: res.data,
            isLoading: false
          });
        }
      });
  };

  handlePopup = () => {
    this.setState({
      isPopup: !this.state.isPopup
    });
  };

  handlePopupStatus = (val, id, text, t1, t2) => {
    this.handlePopup();
    this.setState({
      hostStatus: val,
      hostId: id,
      hostChanges: text,
      popupText1: t1,
      popupText2: t2
    });
  };

  handleConfirm = e => {
    e.preventDefault();
    let _this = this;
    let formData = new FormData();

    this.setState({
      isPopup: false
    });

    formData.append("todo", "hosting_status_change");
    formData.append("id", this.state.hostId);

    if (this.state.hostChanges === "status") {
      formData.append("active", this.state.hostStatus);
    } else if (this.state.hostChanges === "instant_booking") {
      formData.append("is_ins_book_list", this.state.hostStatus);
    } else if (this.state.hostChanges === "delete_list") {
      formData.append("is_delete", this.state.hostStatus);
    }

    axios
      .post(`${constant.phpHost}action/dashboard.php`, formData, {
        headers: {
          "Content-Type": "text/plain"
        }
      })
      .then(response => {
        _this.hosting();
      });
  };

  // It works above render
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    let { isPopup, spaces, isLoading } = this.state;

    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      initOnLoad: true,
      nextSlidesToPreload: 1,
      fade: true
    };

    return (
      <div>
        {isPopup ? (
          <PopupComp ref="call_pop" isPopup={this.handlePopup}>
            <div align="center" className="form-group">
              <h2>{this.state.popupText1}</h2>
              <p>{this.state.popupText2}</p>
            </div>
            <div className="confirm_btn">
              <button onClick={this.handleConfirm}>
                <i className="fa fa-check" />
                Yes
              </button>
              <button
                type="button"
                onClick={() => this.refs.call_pop.handleRemoveClass()}
              >
                <i className="fa fa-close" />
                No
              </button>
            </div>
          </PopupComp>
        ) : null}

        <div className="edit-profile">
          <div className="block host">
            <div className="left_" id="header_tab2">
              <div className="tab">
                <a
                  href={`/have-desk/add/${Math.floor(
                    100000 + Math.random() * 999999
                  )}`}
                >
                  <i className="fa fa-plus" />
                  Add Listing
                </a>
              </div>
            </div>
            <div className="right_">
              <div className="space-block">
                {!isLoading ? (
                  spaces && spaces.length > 0 ? (
                    spaces.map((list, i) => (
                      <div
                        id={list.id}
                        className={`rows ${list.show ? "show" : ""}`}
                        key={i}
                      >
                        <div className="left">
                          <a href={list.url}>
                            <Slider {...settings}>
                              {list.images.map((image, i) => (
                                <img src={image} alt="" key={i} />
                              ))}
                            </Slider>
                          </a>
                        </div>
                        <div className="right">
                          <div className="content">
                            <div>
                              <h3>
                                <a href={list.url}>{list.title}</a>
                              </h3>
                              <a href={list.url}>
                                <p>
                                  <i>Up to </i>
                                  <i>
                                    {list.space.quantity} {list.space.q_name} |{" "}
                                    {list.location.place}
                                  </i>
                                </p>
                              </a>
                              <div className="text">
                                <p>
                                  Type:{" "}
                                  <span className="price">
                                    {list.space.type === 1
                                      ? "Desk"
                                      : list.space.type === 2
                                      ? "Meeting Room"
                                      : "Cafe"}
                                  </span>
                                </p>
                                <p>
                                  Status:{" "}
                                  <span
                                    onClick={() =>
                                      this.handlePopupStatus(
                                        list.status === 1 ? 0 : 1,
                                        list.id,
                                        "status",
                                        "Status Change!",
                                        "Are you sure want to change status?"
                                      )
                                    }
                                    className={`btn ${
                                      list.status === 1 ? "active" : ""
                                    }`}
                                  >
                                    {list.status === 1 ? "ONLINE" : "OFFLINE"}
                                  </span>
                                </p>
                                <p>
                                  Instant Booking:{" "}
                                  <span
                                    onClick={() =>
                                      this.handlePopupStatus(
                                        list.instant_booking === 1 ? 0 : 1,
                                        list.id,
                                        "instant_booking",
                                        "Instant Booking Change!",
                                        "Are you sure want to change instant booking?"
                                      )
                                    }
                                    className={`btn ${
                                      list.instant_booking === 1 ? "active" : ""
                                    }`}
                                  >
                                    {list.instant_booking === 1 ? "ON" : "OFF"}
                                  </span>
                                </p>
                                <p>
                                  Discount:{" "}
                                  <span className="price">
                                    {list.discount ? "Yes" : "No"}
                                  </span>
                                </p>
                              </div>
                            </div>

                            <div className="bottom">
                              <span className="created">
                                Created: {list.created}
                              </span>
                              <span className="price_">
                                <PriceComp price={list.price} />{" "}
                                {list.isLongTerms === 1 ? (
                                  <i>/{list.long_term}</i>
                                ) : (
                                  <i>
                                    /{list.space.type === 1 ? "day" : "hour"}
                                  </i>
                                )}
                              </span>
                            </div>
                          </div>

                          <div className="edit_btn">
                            <a
                              href={`${constant.url}have-desk/edit/${list.en_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="fa fa-edit" title="Edit Listing" />
                            </a>
                            <span>
                              <i className="fa fa-link" title="Edit URL" />
                            </span>
                            <a
                              href={list.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="fa fa-eye" title="View Listing" />
                            </a>
                            <span>
                              <i
                                onClick={() =>
                                  this.handlePopupStatus(
                                    1,
                                    list.id,
                                    "delete_list",
                                    "Delete Listing!",
                                    "Are you sure want to delete list?"
                                  )
                                }
                                className="fa fa-trash"
                                title="Delete Listing"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>No Listing Spaces</div>
                  )
                ) : (
                  <LoadingComp customStyle={{ padding: "200px 0" }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
